import React from 'react';
import { ToastContainer } from 'react-toastify';
import './Toasts.scss';

export function Toasts() {
  return (
    <>
      <ToastContainer position="bottom-right" />
    </>
  );
}
